/* istanbul ignore file */
import { DateTime } from 'luxon';
import React from 'react';
export const TZ_AMERICA_LOS_ANGELES = 'America/Los_Angeles';
export const TZ_AMERICA_BOISE = 'America/Boise';
export const TZ_AMERICA_WINNIPEG = 'America/Winnipeg';
export const TZ_AMERICA_NEW_YORK = 'America/New_York';
export const TIMEZONES = [TZ_AMERICA_LOS_ANGELES, TZ_AMERICA_BOISE, TZ_AMERICA_WINNIPEG, TZ_AMERICA_NEW_YORK];

/**
 * Splits TZ from 'EDT'/'EST' to 'ET' (removes Daylight/Standard)
 * @param time
 * @returns
 */
export const splitTimezone = time => {
  const hasMultipleWords = time.search(' ') > -1;
  const positions = hasMultipleWords ? time.split(' ') : time.split('');
  const first = positions[0];
  const last = positions[positions.length - 1];
  return hasMultipleWords ? `${first} ${last}` : `${first}${last}`;
};
export const formatTimezone = (value, fullTimeZoneName = false) => {
  const abbreviationOrFull = fullTimeZoneName ? 'ZZZZZ' : 'ZZZZ';
  const zone = DateTime.local().setZone(value).toFormat(abbreviationOrFull);
  return splitTimezone(zone);
};
export const TIMEZONES_LABELS = [{
  label: formatTimezone(TZ_AMERICA_LOS_ANGELES),
  value: TZ_AMERICA_LOS_ANGELES
}, {
  label: formatTimezone(TZ_AMERICA_BOISE),
  value: TZ_AMERICA_BOISE
}, {
  label: formatTimezone(TZ_AMERICA_WINNIPEG),
  value: TZ_AMERICA_WINNIPEG
}, {
  label: formatTimezone(TZ_AMERICA_NEW_YORK),
  value: TZ_AMERICA_NEW_YORK
}];
export const DEFAULT_TIME_ZONE_STATE = {
  setTimeZone: () => {},
  timeZone: TZ_AMERICA_NEW_YORK
};
export const TimeZoneContext = /*#__PURE__*/React.createContext(DEFAULT_TIME_ZONE_STATE);
//# sourceMappingURL=TimeZoneContext.js.map